import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import ModalButtons from '../../components/Modal/ModalButtons';

const DeleteDeniedModal = ({ data }) => {
	const { deleteDeniedListModalStatus, closeDeleteModal, handleDeleteDenied } = data;
	return (
		<Modal show={deleteDeniedListModalStatus.status}>
			<ModalHeading heading={`Delete ${deleteDeniedListModalStatus.type} Input`} />
			<ModalForm>
				<InputsSection>
					<p className='delete_text'>
						Are you sure, you want to delete{' '}
						<span>
							{deleteDeniedListModalStatus.type} {deleteDeniedListModalStatus.data}
						</span>{' '}
						?
					</p>
				</InputsSection>
				<ModalButtons
					submitButtonLabel={`Delete ${deleteDeniedListModalStatus.type}`}
					onSubmit={handleDeleteDenied}
					cancelButtonLabel='Cancel'
					onCancel={closeDeleteModal}
					style={{ justifyContent: 'flex-start' }}
				/>
			</ModalForm>
		</Modal>
	);
};

export default DeleteDeniedModal;
